import dayjs from 'dayjs';

import { RunSchema } from '@/types/schema';

export function isRunIncomplete(
  run: Pick<RunSchema, 'status' | 'start_time'>,
  now = new Date()
) {
  return (
    run.status === 'pending' &&
    dayjs(now).diff(dayjs(run.start_time + 'Z'), 'hour') >= 1
  );
}
